enum Web {
  SINGLE_SIGN_ON = 'web-react-sso',
  PROPERTY_DETAILS = 'web-property-details',
  JOB_SHARING_MVP = 'job-sharing-mvps',
  PROPERTY_DETAILS_PHOTOS_TAB = 'web-property-details-photos-tab',
  PAINT_MEASUREMENTS = 'GPAR-paint-measurement-report',
  VIRTUAL_WALKTHROUGH = 'virtual-walkthrough',
  WEB_UPLOAD = 'web-upload',
  COMMERCE_JOB_ASSIGNMENTS = 'commerce-job-assignments',
  BAUHAUS_LOGO = 'rebrand-bauhaus-logo',
}

enum Mobile {}

enum DesignStudio {
  DS_DOOR_GROUPS_DEBUGGING = 'design-studio-door-changing-debugging',
  /**
   * This feature controls whether DS3D supports multiple saved designs.
   * When this is true the user is able to associate multiple saved designs
   * with each building they load.
   * This flag radically alters the loading/saving/undo/redo and feature api
   * usage of DS3D.
   */
  DESIGN_VERSIONING = 'design-versioning',
}

enum AiDesigner {
  GML_POST_CAPTURE = 'AID_gml-post-capture',
}

enum FeatureTracking {
  RENDERING = 'rendering',
  HOMEOWNER_APP = 'homeowner-web-app',
  VIRTUAL_WALKTHROUGH = 'virtual-walkthrough',
  LEAD_LANDING_PAGE = 'lead-landing-page',
  GEN_AI_EMBED = 'gen-ai-embed',
}

enum NewConstruction {
  CONSTRUCTION_INTERIOR_ESTIMATION = 'construction-interior-estimation',
  CONSTRUCTION_OPTIMIZE_BLUEPRINT_SUBMISSION_FLOW = 'construction-optimize-blueprint-submission-flow',
}

enum Designer {
  START_SCAN = 'web-react-homeowner-start-scan',
  MATERIAL_CALLOUTS = 'web-react-material-callouts',
  MATERIAL_CALLOUTS_PHASE_2 = 'web-react-material-callouts-phase-2',
  INSTANCE_EDIT_SELECTION = 'MEOW_instance_level_region_selection',
  CUSTOMIZE_SAVE_DONE_REORG = 'MEOW-customize-save-done-reorganization',
  DESIGNER_PROJECTS_ON_PROPERTY_LIST = 'MEOW_designer-projects-on-property-list-page',
}

const Value = {
  CONTROL: 'control',
  OFF: 'off',
  ON: 'on',
} as const;

const localhostFeaturesKey = 'local-split-features';

export type StyleGridPagination = {
  pageSize: number;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
type Value = (typeof Value)[keyof typeof Value];

type FeatureFlag = DesignStudio | Web | AiDesigner | Designer | NewConstruction;

export type { FeatureFlag };
export {
  DesignStudio,
  Mobile,
  Value,
  Web,
  localhostFeaturesKey,
  FeatureTracking,
  AiDesigner,
  Designer,
  NewConstruction,
};
